import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ top, right }) => ({
  position: 'absolute',
  top,
  right,
});

const Absolute = ({ top, right, children }) => {
  const { css } = useFela({ top, right });

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

Absolute.propTypes = {
  children: PropTypes.node,
  top: PropTypes.string,
  right: PropTypes.string,
};

export default React.memo(Absolute);
